import React from 'react';
import { Instagram, Phone, MapPin, ExternalLink } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_cda4d3ce-07c4-4663-8a1d-3cb128cb90cd/artifacts/ybet6u5o_cosme-alberdi-logo.jpg';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0d0d0d] border-t border-[#252525]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start">
            <img 
              src={LOGO_URL} 
              alt="Cosme Alberdi" 
              className="w-20 h-20 rounded-full mb-4"
            />
            <h3 className="font-heading text-xl font-bold text-white mb-2">
              Cosme Alberdi
            </h3>
            <p className="font-body text-sm text-gray-400 text-center md:text-left">
              Pub & Restaurante en Rosario
            </p>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col items-center md:items-start">
            <h4 className="font-heading text-sm uppercase tracking-wider text-[#7cb342] mb-4">
              Contacto
            </h4>
            <div className="space-y-3">
              <a 
                href="https://www.google.com/maps/dir//Blvd.+Rondeau+1602,+S2000+Rosario,+Santa+Fe,+Argentina"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-gray-400 hover:text-[#7cb342] transition-colors"
              >
                <MapPin size={16} />
                <span className="font-body text-sm">Blvd. Rondeau 1602, Rosario</span>
              </a>
              <a 
                href="tel:03416802275"
                className="flex items-center gap-2 text-gray-400 hover:text-[#7cb342] transition-colors"
              >
                <Phone size={16} />
                <span className="font-body text-sm">0341 680-2275</span>
              </a>
              <a 
                href="https://www.instagram.com/cosme.alberdi"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-gray-400 hover:text-[#7cb342] transition-colors"
              >
                <Instagram size={16} />
                <span className="font-body text-sm">@cosme.alberdi</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col items-center md:items-start">
            <h4 className="font-heading text-sm uppercase tracking-wider text-[#7cb342] mb-4">
              Enlaces
            </h4>
            <div className="space-y-3">
              <a 
                href="https://wa.me/5493416802275"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-gray-400 hover:text-[#7cb342] transition-colors"
              >
                <ExternalLink size={16} />
                <span className="font-body text-sm">WhatsApp</span>
              </a>
              <a 
                href="https://bit.ly/4cyMld9"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-gray-400 hover:text-[#7cb342] transition-colors"
              >
                <ExternalLink size={16} />
                <span className="font-body text-sm">Pedidos Ya</span>
              </a>
              <a 
                href="https://www.google.com/maps/place/Blvd.+Rondeau+1602,+S2000+Rosario,+Santa+Fe,+Argentina"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-gray-400 hover:text-[#7cb342] transition-colors"
              >
                <ExternalLink size={16} />
                <span className="font-body text-sm">Google Maps</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-[#252525]">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 text-center">
            <span className="font-body text-sm text-gray-500">
              © {currentYear} Cosme Alberdi
            </span>
            <span className="hidden sm:inline text-gray-600">·</span>
            <span className="font-body text-sm text-gray-500">
              Desarrollado por{' '}
              <a 
                href="https://www.somosappolo.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#7cb342] transition-colors"
              >
                Appolo
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
